import React, { Fragment, useEffect, useState } from "react";
import { Row, Table, Collapse } from "reactstrap";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import { AssetClassTable } from "./AssetClassTable/AssetClassTable";
import PortfolioModal from "../../Modal/PortfolioModal/PortfolioModal";
import arrow from "../../../../public/svg/keyboard_arrow_down.svg";
import { AssetClassDoghnut, SubAssetClassDoghnut } from "../Charts/Chart";

import style from "./PortfolioTable.scss";

export const PortfolioTable = ({ currency, position, portfolioTotal }) => {
  const [isFirstCollapseOpen, setFirstCollapse] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(undefined);
  const [assetQuantity, setAssetQuantity] = useState(undefined);
  const [assetClass, setAssetClass] = useState(
    position.assetClass === undefined || position.assetClass.length === 0
      ? null
      : {
          name: position.assetClass[0].name,
          items: position.assetClass[0].subAssetClass,
        }
  );
  const [modal, setModal] = useState(false);

  const toggle = (asset, quantity) => {
    setSelectedAsset(asset);
    setAssetQuantity(quantity);
    setModal(!modal);
  };

  const handleToggle = () => {
    setFirstCollapse((prev) => !prev);
  };

  const handleSelectAssetClass = ({ data }) => {
    setAssetClass(data);
  };

  const EmptyPortfolio = ({ currency }) => {
    return (
      <div className={style.emptyWrapper} colSpan={7}>
        {currency === "USD" ? (
          <p className={style.emptyMessage}>No hay datos disponibles para la cuenta en dólares.</p>
        ) : (
          <p className={style.emptyMessage}>No hay datos disponibles para la cuenta en guaraníes.</p>
        )}
      </div>
    );
  };

  return (
    <Row className={style.collapseRow}>
      {position.assetClass.length === 0 ? (
        <EmptyPortfolio currency={currency} />
      ) : (
        <Fragment>
          <Table className={style.collapseTable}>
            <thead
              className={!isFirstCollapseOpen ? style.tableHead : style.tableHeadActivated}
              onClick={handleToggle}
            >
              <tr className={style.tableRow}>
                <span colSpan="6" className={style.collapseTitle}>
                  {currency}
                </span>

                <span className={style.collapseTitle} style={{ color: "#EC7000" }}>
                  <FormattedNumber
                    value={+position.cashTotal + +position.valueTotal}
                    minimumFractionDigits={currency == "USD" ? 2 : 0}
                    maximumFractionDigits={currency == "USD" ? 2 : 0}
                  />
                  <span className={style.collapseTitleText}>Total</span>
                </span>

                <span className={style.collapseTitle}>
                  <FormattedNumber
                    value={position.cashTotal}
                    minimumFractionDigits={currency == "USD" ? 2 : 0}
                    maximumFractionDigits={currency == "USD" ? 2 : 0}
                  />
                  <span className={style.collapseTitleText}>Efectivo</span>
                </span>

                <span className={style.collapseTitle}>
                  <FormattedNumber
                    value={position.valueTotal}
                    minimumFractionDigits={currency == "USD" ? 2 : 0}
                    maximumFractionDigits={currency == "USD" ? 2 : 0}
                  />
                  <span className={style.collapseTitleText}>Valores</span>
                </span>
                <img
                  className={!isFirstCollapseOpen ? style.arrow : style.arrowActivated}
                  src={arrow}
                  alt="arrow image"
                />
              </tr>
            </thead>
            <tbody>
              <Collapse className={style.collapse} isOpen={isFirstCollapseOpen}>
                {position.assetClass.map((itemCuentas, indexCuentas) => {
                  return (
                    <AssetClassTable
                      key={indexCuentas}
                      itemCuentas={itemCuentas}
                      toggle={toggle}
                      position={position}
                      currency={currency}
                      portfolioTotal={portfolioTotal}
                    />
                  );
                })}
                <div className={style.chartsRow}>
                  <AssetClassDoghnut position={position} onSelectItem={handleSelectAssetClass} />
                  {assetClass && <SubAssetClassDoghnut assetClass={assetClass} />}
                </div>
              </Collapse>
            </tbody>
          </Table>
          {selectedAsset != undefined ? (
            <PortfolioModal
              modal={modal}
              toggle={toggle}
              asset={selectedAsset}
              assetQuantity={assetQuantity}
            />
          ) : null}
        </Fragment>
      )}
    </Row>
  );
};
